import rsosIcon from '@rsos/components/capstone/PushNotifications/RSOS-Brandmark.png';
import {
  trackPushNotificationEnabled,
  trackPushNotificationDenied,
} from './pushNotificationsTracking';

interface PushNotification {
  title: string;
  options?: Record<string, unknown>;
  callback?: () => void;
}

/**
 * check if notification.permission is granted, else prompt
 * possible choices { granted, denied, default }
 * cannot request permission if permission is denied.
 */
export const hasNotificationPermission = (irpVersion: string) => {
  const permission =
    typeof Notification !== 'undefined' ? Notification?.permission : null;

  if (permission && permission === 'granted') {
    return true;
  } else if (permission && permission !== 'denied') {
    Notification.requestPermission().then(function (permission) {
      if (permission === 'granted') {
        trackPushNotificationEnabled(irpVersion);
        return true;
      }
      trackPushNotificationDenied(irpVersion);
    });
  }
  return false;
};

/**
 * spawns a new web push notification
 * @param title first param of Notification. title is required as first parameter, separate from {options}
 * @param options second param of Notification. includes {body, icon, image, etc}
 * @param callback callback function to be invoked after clicking on the push notification
 */
export const pushNotification = async ({
  title,
  options = { icon: rsosIcon },
  callback,
}: PushNotification) => {
  const notification = new Notification(title, options);
  notification.onclick = e => {
    e.preventDefault();
    notification.close();
    if (callback) {
      callback();
    }
  };
};
